import React, { useEffect, useRef, useState } from "react";
import { AddCircle, NorthWest } from "@mui/icons-material";
import {
  Button,
  Checkbox,
  FormControl,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { DesktopDateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { Input } from "@100mslive/roomkit-react";
import FullPageProgress from "../../FullPageProgress";
import PostEditor from "../../Post/Editor";
import { ToastManager } from "../../Toast/ToastManager";
import PostTagCreateModal from "./PostTagCreateModal";
import { SESSION_AUTH } from "../../../common/auth";
import { COMPANY_SERVICES, POST_SERVICES } from "../../../services";
import { POST_STATUS } from "../../../common/constants";

const CompanyPostEdit = props => {
  const { setPostsAction, orgId, postId } = props;
  const { isUserSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const [postTitle, setPostTitle] = useState("");
  const [postBody, setPostBody] = useState("");
  const [postImages, setPostImages] = useState([]);
  const [status, setStatus] = useState(POST_STATUS?.[1]?.value);
  const [publishedAt, setPublishedAt] = useState("");
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [author, setAuthor] = useState("");
  const [membersList, setMembersList] = useState([]);
  const dataFetched = useRef(null);
  const [postData, setpPostData] = useState("");

  const [tags, setTags] = useState([]);
  const [openTagDrop, setOpenTagDrop] = useState(false);
  const [createTag, setCreateTag] = useState(false);
  const [tagList, setTagList] = useState([]);

  const onPostSave = () => {
    if (!postTitle.trim()) {
      ToastManager.addToast({ title: "Please enter post title" });
      return;
    }

    if (!postBody) {
      ToastManager.addToast({ title: "Please enter post descritpion" });
      return;
    }

    if (!status) {
      ToastManager.addToast({ title: "Please select post visibility" });
      return;
    }
    if (
      (status === POST_STATUS?.[2]?.value ||
        status === POST_STATUS?.[3]?.value) &&
      !publishedAt
    ) {
      ToastManager.addToast({ title: "Please add scheduled date" });
      return;
    }
    if (!category) {
      ToastManager.addToast({ title: "Please select post category" });
      return;
    }
    if (!author) {
      ToastManager.addToast({ title: "Please select post author" });
      return;
    }

    setLoading(true);

    const postdData = new FormData();

    postImages.forEach((file, index) => {
      if (file.objUrl && postBody.includes(file.objUrl)) {
        postdData.append("postImages" + (index + 1), file);
        postdData.append("postImages" + (index + 1) + "url", file.objUrl);
      }
    });

    postdData.append("postTitle", postTitle.trim());
    postdData.append("postBody", postBody);
    postdData.append("status", status);
    postdData.append("category", category);
    postdData.append("author", author);
    postdData.append("userId", isUserSession?.userId);
    postdData.append("org", isUserSession?.org?.id);
    postdData.append("accountId", orgId);
    postdData.append("id", postId);
    postdData.append("tags", tags);
    if (
      status === POST_STATUS?.[2]?.value ||
      status === POST_STATUS?.[3]?.value
    ) {
      postdData.append("publishedAt", publishedAt);
    }

    POST_SERVICES.update(postdData)
      .then(data => {
        if (data.code === 200) {
          ToastManager.addToast({ title: data.message });
          setPostsAction("");
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({ title: err?.message });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (dataFetched?.current) return;
    dataFetched.current = true;
    POST_SERVICES.edit({
      userId: isUserSession?.userId,
      org: isUserSession?.org?.id,
      accountId: orgId,
      id: postId,
    })
      .then(data => {
        if (data.code === 200) {
          setCategory(data.data?.category || "");
          setTags(data.data?.tags || []);
          setPostBody(data.data?.postBody || "");
          setPostTitle(data.data?.postTitle || "");
          setStatus(data.data?.status || "");
          setAuthor(data.data?.author || "");
          getCatList();
          getMembersList();
          setpPostData(data.data);
          if (
            data.data?.status === POST_STATUS?.[2]?.value ||
            data.data?.status === POST_STATUS?.[3]?.value
          ) {
            setPublishedAt(data.data?.publishedAt || "");
          }
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
          setPostsAction("");
        }
      })
      .catch(err => {
        setPostsAction("");
        ToastManager.addToast({ title: err.message });
      })
      .finally(() => {
        setLoading(false);
      });
    const getCatList = () => {
      POST_SERVICES.categoryList()
        .then(data => {
          if (data.code === 200) {
            setCategoryList(data?.data);
          } else {
            ToastManager.addToast({ title: data.message });
          }
        })
        .catch(err => {
          ToastManager.addToast({ title: err.message });
        });

      POST_SERVICES.tagList()
        .then(data => {
          if (data.code === 200) {
            setTagList(data?.data);
          } else {
            ToastManager.addToast({ title: data.message });
          }
        })
        .catch(err => {
          ToastManager.addToast({ title: err.message });
        });
    };
    const getMembersList = () => {
      COMPANY_SERVICES.membersList({ id: orgId })
        .then(data => {
          if (data.code === 200) {
            setMembersList(data?.data);
          } else {
            ToastManager.addToast({ title: data.message });
          }
        })
        .catch(err => {
          ToastManager.addToast({ title: err.message });
        });
    };
  }, [isUserSession, LOGOUT_USER_SESSION, orgId, postId, setPostsAction]);

  const onTagsChange = event => {
    const {
      target: { value },
    } = event;
    const lastValue = value[value.length - 1];
    if (lastValue === "create_new_tag") {
      setCreateTag(true);
      setOpenTagDrop(false);
      return;
    }
    setTags(typeof value === "string" ? value.split(",") : value);
  };

  const onNewTag = t => {
    setCreateTag(false);
    if (t) {
      if (!tagList.includes(t)) {
        setTagList(old => [...old, t]);
      }
      if (!tags.includes(t)) {
        setTags(old => [...old, t]);
      }
    }
  };

  return (
    <React.Fragment>
      {loading ? <FullPageProgress fixed /> : null}
      {postData ? (
        <>
          <div className="product-launch-header">
            <Button
              color="secondary"
              variant="outlined"
              className="events6ix-btn events6ix-btn-secondary events6ix-btn-secondary-sm "
              onClick={() => setPostsAction("")}
            >
              <NorthWest />
            </Button>

            <div className="product-launch-header-type">
              <Select
                className="custom-select"
                sx={{
                  height: "42px",
                  background: "transparent !important",
                  width: "100%",
                }}
                value={status}
                onChange={e => setStatus(e.target.value)}
                displayEmpty
              >
                <MenuItem value="" disabled>
                  Select Visibility
                </MenuItem>
                {Object.keys(POST_STATUS)?.map((item, key) => {
                  return (
                    <MenuItem key={key} value={POST_STATUS?.[item]?.value}>
                      {POST_STATUS?.[item]?.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </div>

            {status === POST_STATUS?.[2]?.value ||
            status === POST_STATUS?.[3]?.value ? (
              <div className="product-launch-header-type">
                <div className="custom-form-date">
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    localeText={{
                      clearButtonLabel: "CLEAR",
                      okButtonLabel: "APPLY",
                    }}
                  >
                    <DesktopDateTimePicker
                      closeOnSelect={false}
                      autoFocus={false}
                      onChange={newValue => {
                        newValue?.$d
                          ? setPublishedAt(newValue.$d)
                          : setPublishedAt("");
                      }}
                      minDateTime={dayjs(new Date())}
                      value={publishedAt ? dayjs(publishedAt) : null}
                      format="ddd, MMM DD YYYY hh:mm A"
                      slotProps={{
                        actionBar: {
                          actions: ["clear", "accept"],
                        },
                        textField: {
                          placeholder: "Add Date",
                        },

                        mobilePaper: {
                          className: "custom-dateTimePicker",
                        },
                        desktopPaper: {
                          className: "custom-dateTimePicker",
                        },
                      }}
                    />
                  </LocalizationProvider>
                </div>
              </div>
            ) : null}

            {categoryList?.length > 0 ? (
              <div className="product-launch-header-type">
                <Select
                  className="custom-select"
                  sx={{
                    height: "42px",
                    background: "transparent !important",
                    width: "100%",
                  }}
                  value={category}
                  onChange={e => setCategory(e.target.value)}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select Category
                  </MenuItem>
                  {categoryList?.map((item, key) => {
                    return (
                      <MenuItem key={key} value={item.id}>
                        {item?.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </div>
            ) : null}

            {membersList?.length > 0 ? (
              <div className="product-launch-header-type">
                <Select
                  className="custom-select"
                  sx={{
                    height: "42px",
                    background: "transparent !important",
                    width: "100%",
                  }}
                  value={author}
                  onChange={e => setAuthor(e.target.value)}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select Author
                  </MenuItem>
                  {membersList?.map((item, key) => {
                    return (
                      <MenuItem key={key} value={item.id}>
                        {item?.name}
                        <small className="text-primary ml-5">
                          {item?.role}
                        </small>
                      </MenuItem>
                    );
                  })}
                </Select>
              </div>
            ) : null}

            <div className="product-launch-header-type">
              <Select
                className="custom-select"
                sx={{
                  height: "42px",
                  background: "transparent !important",
                  width: "100%",
                  maxWidth: "250px",
                }}
                value={tags}
                open={openTagDrop}
                onOpen={() => setOpenTagDrop(true)}
                onClose={() => setOpenTagDrop(false)}
                multiple
                displayEmpty
                onChange={onTagsChange}
                input={<OutlinedInput />}
                renderValue={selected => {
                  if (selected.length === 0) {
                    return <MenuItem>Select Tags </MenuItem>;
                  }

                  return selected.join(", ");
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300,
                    },
                  },
                }}
                inputProps={{ "aria-label": "Without label" }}
              >
                <MenuItem disabled value="">
                  <small>Tags</small>
                </MenuItem>
                <MenuItem value="create_new_tag" style={{ fontSize: "90%" }}>
                  <AddCircle fontSize="small" /> &nbsp; Create Tag
                </MenuItem>
                {tagList?.map((item, key) => (
                  <MenuItem key={key} value={item}>
                    <Checkbox checked={tags.includes(item)} />
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </div>

            <Button
              color="primary"
              variant="outlined"
              className="events6ix-btn events6ix-btn-primary ml-auto "
              onClick={onPostSave}
            >
              Update
            </Button>
          </div>

          <FormControl className="custom-form-group">
            <Input
              name="posttitle"
              className="custom-form-input"
              value={postTitle}
              placeholder="Enter post title"
              onChange={e => {
                if (e.target?.value?.length <= 256)
                  setPostTitle(e.target?.value?.replace(/(<([^>]+)>)/gi, ""));
              }}
              maxLength={256}
            />
          </FormControl>
          <PostEditor
            content={postBody}
            setContent={setPostBody}
            setImages={setPostImages}
          />

          {createTag && (
            <PostTagCreateModal
              onClose={() => setCreateTag(false)}
              onUpdate={onNewTag}
            />
          )}
        </>
      ) : null}
    </React.Fragment>
  );
};

export default CompanyPostEdit;
